import type { VuetifyOptions } from 'vuetify';
import { VBtn, VChip, VSelect } from 'vuetify/components';

export default {
    VBtnText: VBtn,
    VBtnIcon: VBtn,
    VSelectRound: VSelect,
    VTag: VChip,
} as VuetifyOptions['aliases'];
